const fetcherUtils = require('od-modules/utils/fetcher');
const withRetry = require('./with.retry');

const formatUrl = (service = '') => `${Odigeo.Settings.property('appContext')}${service}`;

class Fetcher {
    constructor({formatter = formatUrl} = {}) {
        this.formatter = formatter;
    }

    get(url = '', options = {}) {
        return withRetry(() => fetcherUtils.get(this.formatter(url)).json(), options);
    }

    post(url = '', data = {}, options = {}) {
        return withRetry(() => fetcherUtils.post(this.formatter(url), data).json(), options);
    }

    put(url = '', data = {}, options = {}) {
        return withRetry(() => fetcherUtils.put(this.formatter(url), data).json(), options);
    }
}

module.exports = Fetcher;
